var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center"},[(_vm.user)?_c('p',{staticClass:"mb-0 base-section-title"},[_vm._v(" "+_vm._s(_vm.$t("shared.hello"))+", "+_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name)+" ")]):_vm._e(),_c('inline-svg',{staticClass:"ms-2 mr-2",attrs:{"src":_vm.hello_illustration}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }